import React from "react";
import { MapPin } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import { groupFormerPresidentTerms } from "@/lib/formerPresidents";

export default function FormerPresidentsSection({ section, presidents }) {
  const rows = groupFormerPresidentTerms(presidents || []);
  if (!rows.length) return null;

  const displayRows = [...rows].reverse();

  return (
    <section className="container-bcs py-20 sm:py-24" data-testid="former-presidents-section">
      <SectionHeading
        eyebrow={section?.eyebrow || "Our history"}
        title={section?.title || "Former Presidents"}
        subtitle={
          section?.subtitle ||
          "Leaders who have guided the Sabha through decades of parish units, civic witness and community service."
        }
      />

      <div className="mt-12 max-w-4xl mx-auto">
        <div className="relative">
          <div
            className="hidden sm:block absolute left-[6.75rem] top-3 bottom-3 w-px bg-gradient-to-b from-gold/10 via-gold/40 to-gold/10"
            aria-hidden
          />

          <ul className="space-y-0">
            {displayRows.map((row, i) => (
              <li
                key={`${row.period}-${row.name}-${i}`}
                className="group relative grid grid-cols-1 sm:grid-cols-[6.75rem_1fr] gap-3 sm:gap-8 py-5 border-b border-cream-dark last:border-b-0"
                data-testid={`former-president-${i}`}
              >
                <div className="sm:text-right">
                  <span className="inline-flex sm:flex sm:justify-end">
                    <span className="font-serif text-sm sm:text-base font-semibold text-maroon whitespace-nowrap tabular-nums">
                      {row.period}
                    </span>
                  </span>
                </div>

                <div className="relative sm:pl-2">
                  <span
                    className="hidden sm:block absolute -left-[1.35rem] top-2.5 h-2.5 w-2.5 rounded-full bg-gold ring-4 ring-cream group-hover:scale-110 transition-transform"
                    aria-hidden
                  />

                  <div className="rounded-xl border border-cream-dark bg-white px-5 py-4 shadow-sm transition-shadow group-hover:shadow-card">
                    <h3 className="font-serif text-lg sm:text-xl font-semibold text-ink leading-snug">
                      {row.name}
                    </h3>
                    <p className="mt-2 flex items-start gap-2 text-sm text-ink-muted">
                      <MapPin size={15} className="shrink-0 mt-0.5 text-gold-dark" aria-hidden />
                      <span>{row.parish}</span>
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
